import {
  ActionsTypes,
  ADD_CUSTOMER_ENTRY,
  SET_COVER,
  SET_COVER_DISPLAY_NAME,
  SET_CURRENT_STEP,
  ADD_NEXT_STEP_TO_STEP_LIST,
  REMOVE_STEP_FROM_STEP_LIST,
  SET_LAST_EDIT_STEP,
  SET_SHOW_STEP_ACTION,
  SET_STEP_GROUP,
  SET_CUSTOMER_ENTRY,
  REMOVE_CUSTOMER_ENTRY,
  RESET_STEP_ENGINE,
  SET_BACK_TO_HOME,
  SET_SHOW_ELIGIBILITY_MODAL,
  ADD_GLOBAL_DATA,
  ADD_REPEATABLE_GLOBAL_DATA,
  REMOVE_REPEATABLE_GLOBAL_DATA,
  REMOVE_GLOBAL_DATA,
  REMOVE_DECLARATION_GLOBAL_DATA,
  SET_GO_TO_LOGIN_ERROR,
  SET_DONT_SHOW_POPUP_REDIRECT_URL,
  SET_RECEIVED_STEP,
  SET_DISABLED_NEXT_BUTTON,
  SET_SHOW_ERROR_MODAL,
  SET_STEP_ENGINE_DEVICE_TYPE,
  SET_SHOW_RATING_MODAL,
  SET_STEP_ENGINE_SUBSCRIPTION,
  SET_STEP_ENGINE_SUBSCRIBER,
  SET_STEP_ENGINE_CREATED_CLAIM,
  SET_CURRENT_STEP_GROUP,
  ADD_COMPONENT_DATA_TO_ONE_STEP,
  DECREMENT_INSURED_GROUP_INDEX_COMPONENT,
  SET_COMPONENT_LIST,
  REMOVE_STEP_FROM_STEP_LIST_BY_INDEX_AND_NAME,
  REMOVE_STEPS_FROM_STEP_LIST_AFTER_INDEX,
  REMOVE_INSURED_GOOD_BY_INDEX,
  REMOVE_INSURED_GROUP_BY_INDEX,
  SET_LAST_REPEATABLE_STEP_GROUP,
  SET_CURRENT_REPEATABLE_STEP_GROUP,
  ADD_STEP_GROUP_TO_ONE_STEP,
  REMOVE_REPEATABLE_DECLARATION_GLOBAL_DATA,
  DECREMENT_LAST_REPEATABLE_STEP_GROUP,
  DECREMENT_CURRENT_REPEATABLE_STEP_GROUP,
} from './step-engine-actions';
import { initialState, StepEngineState } from './step-engine-state';
import update from 'immutability-helper';
import { isMobileDevice } from 'app/shared/util/method-util';

// Reducers

export default (state: StepEngineState = initialState, action: ActionsTypes): StepEngineState => {
  switch (action.type) {
    case SET_RECEIVED_STEP: {
      return {
        ...state,
        stepData: {
          ...state.stepData,
          receivedStep: action.payload,
        },
      };
    }
    case SET_CURRENT_STEP: {
      return {
        ...state,
        stepData: { ...state.stepData, currentSteps: action.payload },
      };
    }
    case SET_CURRENT_REPEATABLE_STEP_GROUP: {
      return {
        ...state,
        stepData: { ...state.stepData, currentRepeatableStepGroup: action.payload },
      };
    }
    case ADD_NEXT_STEP_TO_STEP_LIST: { // action.payload: {StepList, stepIndex}
      // Si la step existe déjà dans le store, on sort
      const existsInArray = state.stepList.some(
        step => step.stepName === action.payload.step.stepName && step.insuredGroupIndex === action.payload.step.insuredGroupIndex
      )
      if (existsInArray) {
        return state;
      }
      return update(state, {
        stepList: {
          $splice: [
            [action.payload.currentIndex, 0, action.payload.step]
          ]
        }
      })
    }
    case ADD_COMPONENT_DATA_TO_ONE_STEP: {
      return update(state, {
        stepList: {
          [action.payload.currentIndex]: {
            component: { $set: action.payload.component },
          }
        }
      })
    }
    case DECREMENT_INSURED_GROUP_INDEX_COMPONENT: {
      return update(state, {
        stepList: {
          [action.payload.stepIndex]: {
            component: {
              props : {
                insuredGroupIndex : { $set: state.stepList[action.payload.stepIndex].component.props.insuredGroupIndex - 1}
              }
            }
          }
        }
      })
    }
    case ADD_STEP_GROUP_TO_ONE_STEP: {
      return update(state, {
        stepList: {
          [action.payload.currentIndex]: {
            stepGroup: { $set: action.payload.stepGroup }
          }
        }
      })
    }
    case REMOVE_STEP_FROM_STEP_LIST: { // action.payload: index
      return update(state, {
        stepList: { $splice: [[action.payload, 1]] }
      });
    }
    case REMOVE_STEP_FROM_STEP_LIST_BY_INDEX_AND_NAME: { // action.payload: {index, stepName}
      const tmpIndex = state.stepList.findIndex(x => x.stepName === action.payload.stepName);
      if (tmpIndex === action.payload.index) {
        return update(state, {
          stepList: { $splice: [[action.payload.index, 1]] }
        });
      }
      return;
    }
    case REMOVE_STEPS_FROM_STEP_LIST_AFTER_INDEX: {
      return update(state, {
        stepList: { $splice: [[action.payload + 1]] }
      });
    }
    case REMOVE_INSURED_GOOD_BY_INDEX: { // action.payload: index
      return update(state, {
        globalData: {
          insuredGoods: { $splice: [[action.payload.index, 1]] }
        },
        declarationGlobalData: {
          insuredGoods: { $splice: [[action.payload.index, 1]] }
        },
      })
    }
    case REMOVE_INSURED_GROUP_BY_INDEX: {

      // créer une nouvelle liste sans les éléments à supprimer
      const updatedStepListWithDelete = state.stepList.filter(x => x.insuredGroupIndex !== action.payload.index);
      // créer une nouvelle liste avec les insuredGroupIndex actualisé
      const updatedStepList = updatedStepListWithDelete.map(step => {
        if (step.insuredGroupIndex > action.payload.index) {
          return { ...step, insuredGroupIndex: step.insuredGroupIndex - 1 };
        }
        return step;
      });
      // Retournez un nouvel état avec la liste mise à jour
      return { ...state, stepList: updatedStepList };
    }
    case SET_COMPONENT_LIST: {
      const components = {};

      action.payload.views.forEach(view => {
        components[view.props.dataKey] = view
      });

      return {
        ...state,
        components
      }
    }
    case SET_CURRENT_STEP_GROUP: {
      return {
        ...state,
        stepData: { ...state.stepData, currentStepGroup: action.payload },
      };
    }
    case SET_LAST_EDIT_STEP: {
      return {
        ...state,
        stepData: { ...state.stepData, lastEditStep: action.payload },
      };
    }
    case SET_STEP_ENGINE_SUBSCRIPTION:
      return {
        ...state,
        stepData: { ...state.stepData, subscriptionDto: action.payload },
      };
    case SET_STEP_ENGINE_SUBSCRIBER:
      return {
        ...state,
        stepData: { ...state.stepData, subscriptionDto: { ...state.stepData.subscriptionDto, subscriber: action.payload } },
      };
    case SET_STEP_ENGINE_CREATED_CLAIM:
      return {
        ...state,
        stepData: { ...state.stepData, createdClaimNumber: action.payload },
      };
    case SET_COVER:
      return {
        ...state,
        stepData: {
          ...state.stepData,
          journeyData: { ...state.stepData.journeyData, cover: action.payload },
        },
      };
    case SET_COVER_DISPLAY_NAME:
      return {
        ...state,
        stepData: {
          ...state.stepData,
          journeyData: {
            ...state.stepData.journeyData,
            coverDisplayName: action.payload,
          },
        },
      };
    case SET_CUSTOMER_ENTRY: {
      return {
        ...state,
        stepData: {
          ...state.stepData,
          journeyData: {
            ...state.stepData.journeyData,
            customerEntry: action.payload,
          },
        },
      };
    }

    case ADD_CUSTOMER_ENTRY: {
      return {
        ...state,
        stepData: {
          ...state.stepData,
          journeyData: {
            ...state.stepData.journeyData,
            customerEntry: {
              ...state.stepData.journeyData.customerEntry,
              [action.payload.customerEntryName]: action.payload.value,
            },
          },
        },
      };
    }

    case REMOVE_CUSTOMER_ENTRY: {
      return update(state, {
        stepData: {
          journeyData: {
            customerEntry: { $unset: [action.payload.customerEntryName] },
          },
        },
      });
    }

    case ADD_GLOBAL_DATA: {
      return {
        ...state,
        globalData: {
          ...state.globalData,
          [action.payload.key]: action.payload.value,
        },
        declarationGlobalData: {
          ...state.declarationGlobalData,
          [action.payload.key]: action.payload.value,
        },
      };
    }
    case ADD_REPEATABLE_GLOBAL_DATA: {
      if (state.globalData.insuredGoods[action.payload.repeatableStepGroupIndex] === undefined) {
        return update(state, {
          globalData: {
            insuredGoods: { $push: [{ [action.payload.key]: action.payload.value }] }
          },
          declarationGlobalData: {
            insuredGoods: { $push: [{ [action.payload.key]: action.payload.value }] }
          },
        })
      } else {
        if (state.declarationGlobalData.insuredGoods[action.payload.repeatableStepGroupIndex] === undefined) {
          return update(state, {
            globalData: {
              insuredGoods: {
                [action.payload.repeatableStepGroupIndex]: {
                  [action.payload.key]: { $set: action.payload.value }
                }
              }
            },
            declarationGlobalData: {
              insuredGoods: { $push: [{ [action.payload.key]: action.payload.value }] }
            },
          })
        } else {
          return update(state, {
            globalData: {
              insuredGoods: {
                [action.payload.repeatableStepGroupIndex]: {
                  [action.payload.key]: { $set: action.payload.value }
                }
              }
            },
            declarationGlobalData: {
              insuredGoods: {
                [action.payload.repeatableStepGroupIndex]: {
                  [action.payload.key]: { $set: action.payload.value }
                }
              }
            },
          })
        }
      }
    }
    case REMOVE_GLOBAL_DATA: {
      return update(state, { globalData: { $unset: [action.payload.key] } });
    }
    case REMOVE_DECLARATION_GLOBAL_DATA: {
      return update(state, { declarationGlobalData: { $unset: [action.payload.key] } });
    }
    case REMOVE_REPEATABLE_DECLARATION_GLOBAL_DATA: {
      return update(state, { declarationGlobalData: { insuredGoods: { $splice: [[action.payload.insuredGroupIndex]] } } });
    }
    case REMOVE_REPEATABLE_GLOBAL_DATA: {
      return update(state, {
        globalData: {
          insuredGoods: {
            [action.payload.repeatableStepGroupIndex]: {
              [action.payload.key]: { $set: undefined }
            }
          }
        },
        declarationGlobalData: {
          insuredGoods: {
            [action.payload.repeatableStepGroupIndex]: {
              [action.payload.key]: { $set: undefined }
            }
          }
        }
      });
    }
    case RESET_STEP_ENGINE: {
      return {
        ...state,
        stepData: {
          currentStepGroup: '',
          currentSteps: ['GET_FIRST_STEP'],
          lastEditStep: '',
          additionalStep: '',
          journeyData: {
            customerEntry: {},
            cover: null,
            coverDisplayName: '',
          },
          showStepAction: null,
          stepGroup: '',
          subscriptionDto: { ...state.stepData.subscriptionDto },
          createdClaimNumber: '',
          receivedStep: null,
          deviceType: state.stepData.deviceType,
          lastRepeatableStepGroup: null,
          currentRepeatableStepGroup: null,
        },
        backToHome: false,
        showEligibilityModal: false,
        showErrorModal: false,
        globalData: {
          subscriptionNumber: state.globalData.subscriptionNumber,
          subscriptionDate: state.declarationGlobalData.subscriptionDate,
          clientNumber: state.globalData.clientNumber,
          mobile: isMobileDevice(),
          insuredGoods: [],
        },
        declarationGlobalData: {
          subscriptionNumber: state.declarationGlobalData.subscriptionNumber,
          subscriptionDate: state.declarationGlobalData.subscriptionDate,
          clientNumber: state.declarationGlobalData.clientNumber,
          mobile: isMobileDevice(),
          insuredGoods: [],
        },
      };
    }
    case SET_BACK_TO_HOME: {
      return {
        ...state,
        backToHome: action.payload,
      };
    }
    case SET_GO_TO_LOGIN_ERROR: {
      return {
        ...state,
        goToLoginError: action.payload,
      };
    }
    case SET_SHOW_ELIGIBILITY_MODAL: {
      return {
        ...state,
        showEligibilityModal: action.payload,
      };
    }
    case SET_DISABLED_NEXT_BUTTON: {
      return update(state, {
        stepList: {
          [action.payload.stepIndex]: {
            disableNextButton: { $set: action.payload.disableNextButton }
          }
        }
      })
    }
    case SET_SHOW_ERROR_MODAL: {
      return {
        ...state,
        showErrorModal: action.payload,
      };
    }
    case SET_SHOW_RATING_MODAL: {
      return {
        ...state,
        showRatingModal: action.payload,
      };
    }
    case SET_SHOW_STEP_ACTION: {
      return {
        ...state,
        stepData: {
          ...state.stepData,
          showStepAction: action.payload,
        },
      };
    }
    case SET_STEP_GROUP: {
      return {
        ...state,
        stepData: {
          ...state.stepData,
          stepGroup: action.payload,
        },
      };
    }
    case SET_STEP_ENGINE_DEVICE_TYPE:
      return {
        ...state,
        stepData: { ...state.stepData, deviceType: action.payload },
      };

    case SET_DONT_SHOW_POPUP_REDIRECT_URL: {
      return {
        ...state,
        stepData: {
          ...state.stepData,
          dontShowPopupRedirectUrl: action.payload,
        },
      };
    }
    case SET_LAST_REPEATABLE_STEP_GROUP:
      return {
        ...state,
        stepData: {
          ...state.stepData,
          lastRepeatableStepGroup: action.payload.lastRepeatableStepGroup
        }
      }
    case DECREMENT_LAST_REPEATABLE_STEP_GROUP:
      return {
        ...state,
        stepData: {
          ...state.stepData,
          lastRepeatableStepGroup: (state.stepData.lastRepeatableStepGroup > 0 ? state.stepData.lastRepeatableStepGroup - 1 : null)
        }
      }
    case DECREMENT_CURRENT_REPEATABLE_STEP_GROUP:
      return {
        ...state,
        stepData: {
          ...state.stepData,
          currentRepeatableStepGroup: (state.stepData.currentRepeatableStepGroup > 0 ? state.stepData.currentRepeatableStepGroup - 1 : null)
        }
      }
    default:
      return state;
  }
};
